<template>
   <div class="layout search-layout">
      <div class="search-header">
         <SearchForm :show-instant-search="false" key="search-layout" />
         <Tabs noBorder>
            <li>
               <span
                  aria-label="button"
                  @click="setDisciplines(getUserDisciplines)"
                  :class="{
                     active: isEqual(getDisciplines, getUserDisciplines),
                  }"
                  >All</span
               >
            </li>
            <li v-if="getUserDisciplines?.includes(1)">
               <span
                  aria-label="button"
                  @click="activeSearch && setDisciplines(1)"
                  :class="{
                     active: getDisciplines == 1,
                     // disabled: !activeSearch,
                  }"
                  >Music</span
               >
            </li>
            <li v-if="getUserDisciplines?.includes(2)">
               <span
                  aria-label="button"
                  @click="activeSearch && setDisciplines(2)"
                  :class="{
                     active: getDisciplines == 2,
                     // disabled: !activeSearch,
                  }"
                  >Dance</span
               >
            </li>
            <li v-if="getUserDisciplines?.includes(3)">
               <span
                  aria-label="button"
                  @click="activeSearch && setDisciplines(3)"
                  :class="{
                     active: getDisciplines == 3,
                     // disabled: !activeSearch,
                  }"
                  >Drama</span
               >
            </li>
            <!-- Action on right side if disciplient is selected -->
            <template #actions>
               <btn
                  v-if="typeof getDisciplines === 'number' && activeSearch"
                  buttonType="small"
                  icon="arrow-right"
                  :to="{
                     name: 'discipline-resources',
                     params: { discipline: disciplineText(getDisciplines) },
                     query: { search: searchQuery },
                  }"
                  :key="getDisciplines"
                  :text="`View All ${startcase(
                     disciplineText(getDisciplines),
                  )}`"
               ></btn>
            </template>
         </Tabs>
      </div>

      <NuxtPage />
   </div>
</template>
<script setup lang="ts">
// const { teachable } = useTeachable();
import startcase from "lodash.startcase";
import isEqual from "lodash.isequal";
const authedStore = useAuthStore();
const { getUserDisciplines } = storeToRefs(authedStore);

const { getDisciplines, setDisciplines, searchQuery, clearSearch } =
   useGlobalSearch();

onBeforeUnmount(() => {
   // If on search results page, set disciplines to all
   // clearSearch();
});
const activeSearch = computed(() => searchQuery.value);
</script>

<style scoped lang="scss">
div.search-header {
   @include px(1, 0, 1);
   border-bottom: 1px solid $border-lt;
}
</style>
